<template>
  <!-- Do not use property cache-items in this autocomplete-->
  <!-- it has some conflicts with no-filter prop-->
  <!-- https://github.com/vuetifyjs/vuetify/issues/11365 -->

  <v-autocomplete
    chips
    clearable
    dense
    outlined
    no-filter
    return-object
    item-value="id"
    item-text="title"
    data-testid="assigneeSelector"
    :append-icon="icon"
    :menu-props="{
      allowOverflow: true, // This prop allow us to be sure of displaying the list of options below the autocomplete. When this props is not passed to v-menu, it auto-position itself if the list of elements is too large, overlaping the area where user is typing the search criteria.
      contentClass: 'autocomplete-menu', // The 'auto' prop invalidates the 'max-height' prop we could pass to v-menu. We have to pass a custom classname as a workaround. https://github.com/vuetifyjs/vuetify/issues/11144#issuecomment-859358889
    }"
    class="assignee-selector"
    ref="autocomplete"
    :hide-details="hideDetails"
    :multiple="multiple"
    :hide-selected="!isSearching"
    :disabled="disabled"
    :items="inputItems"
    :label="labelText"
    :loading="isLoading"
    :rules="validationRules || rules"
    :search-input.sync="searchTerm"
    :value="selectedAccountIds"
    @change="handleChange"
  >
    <template v-slot:prepend-inner>
      <slot />
    </template>
    <template v-if="showEmptyState" v-slot:no-data>
      <EmptyState
        data-testid="assigneeSelector-emptyState"
        :icon="emptyStateIcon"
        :title="emptyStateTitle"
        :message="emptyStateMessage"
      />
    </template>
    <template v-slot:selection="data">
      <span v-if="multiple" class="mb-1">
        <ChipAvatar
          v-bind="data.attrs"
          small
          :account="data.item"
          :vuetifyProps="{
            close: !disabled,
            inputValue: data.selected,
            ripple: false,
          }"
          @click="data.select"
          @click:close="handleRemove(data.item)"
        />
      </span>
      <span v-else class="account-single-name">
        {{ getShortenedName(data.item) }}
      </span>
    </template>

    <template v-slot:item="data">
      <v-list-item-avatar class="d-flex justify-center">
        <v-avatar v-if="data.item.isTeam" color="teal lighten-5">
          <v-icon color="teal">
            mdi-account-group
          </v-icon>
        </v-avatar>
        <UserAvatar v-else size="32px" fontSize="10px" :account="data.item" />
      </v-list-item-avatar>

      <v-list-item-content>
        <div class="d-flex justify-space-between align-center">
          <div>
            <v-list-item-title>
              <text-highlight
                highlightClass="yellow lighten-1"
                data-private
                highlightComponent="span"
                :queries="searchTerm || ''"
              >
                {{ data.item.title }}
              </text-highlight>
            </v-list-item-title>
            <v-list-item-subtitle>
              <text-highlight
                highlightClass="yellow lighten-1"
                data-private
                highlightComponent="span"
                :queries="searchTerm || ''"
              >
                {{ data.item.subtitle }}
              </text-highlight>
            </v-list-item-subtitle>
          </div>
          <v-chip v-if="data.item.isTeam" x-small>
            {{ $t('common.team_one') }}
          </v-chip>
        </div>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import assigneesSelectorMixin from './AssigneesSelectorMixin.vue'

import ChipAvatar from '@/components/ChipAvatar.vue'
import UserAvatar from '@/components/UserAvatar.vue'
import EmptyState from '@/components/EmptyState.vue'

export default {
  mixins: [assigneesSelectorMixin],

  components: {
    UserAvatar,
    ChipAvatar,
    EmptyState,
  },

  props: {
    icon: {
      type: String,
      default: 'mdi-menu-down',
    },
  },
}
</script>

<style lang="scss">
.account-single-name {
  text-transform: capitalize;
}

.assignee-selector .v-select__selections {
  padding-top: 10px !important;
  input {
    top: -2px !important;
  }
}

.autocomplete-menu {
  max-height: 335px !important;
}
</style>
